/** CSS selector for regions that start overlay drag */
export const OVERLAY_DRAG_HANDLE_SELECTOR = '[data-overlay-drag-handle]'

export interface OverlayDragExcludeOptions {
  /** Pointer down is inside a marked drag-handle region. */
  inDragHandle?: boolean
}

/**
 * Ignore drag when pointer down on interactive controls or accordion toggle.
 * Inside `[data-overlay-drag-handle]` allow drag even when header is a `<button>`.
 */
export function isOverlayDragExcludedTarget(
  target: EventTarget | null,
  options: OverlayDragExcludeOptions = {},
): boolean {
  if (!(target instanceof Element)) return true

  if (
    target.closest(
      '.p-accordionheader-toggle-icon, [data-no-overlay-drag], .p-dialog-header-actions',
    )
  ) {
    return true
  }

  if (options.inDragHandle || target.closest(OVERLAY_DRAG_HANDLE_SELECTOR)) {
    return !!target.closest('input, textarea, select, a[href], [data-no-overlay-drag]')
  }

  return !!target.closest(
    ['button', 'a', 'input', 'textarea', 'select', '[contenteditable="true"]'].join(', '),
  )
}

export interface FloatingOverlayDragState {
  x: number
  y: number
  pointerX: number
  pointerY: number
  /** Accordion header: wait for movement before capture (preserve click-to-toggle). */
  deferred: boolean
}

export const OVERLAY_DRAG_THRESHOLD_PX = 4

export function hasOverlayDragThreshold(dx: number, dy: number): boolean {
  return Math.hypot(dx, dy) >= OVERLAY_DRAG_THRESHOLD_PX
}
